<template>
    <div class="tabContent" :class="{active: activeGroupMedia}">
        <div id="group_media_list" :style="isMobileMode?'height:100%;':`height: calc(100vh - ${295+headHeight}px);`">
            <vue-custom-scrollbar class="ps" style="max-height: 100%;">
                <ul class="list" v-if="isDataLoading">
                    <group-media-item-loading v-for="i in 3" :key="i"></group-media-item-loading>
                </ul>
                <ul class="list" v-else>
                    <group-media-item
                        v-for="item in groupList"
                        :key="item.id"
                        :media="item"
                        :view-media="viewMedia"
                        @select-media=" params => $emit('select-media', params) "
                    ></group-media-item>
                </ul>
                
            </vue-custom-scrollbar>
        </div>
    </div>
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar'; 
import GroupMediaItem from './GroupMediaItem.vue';
import GroupMediaItemLoading from './GroupMediaItem.skeleton.vue';

export default {
    components: {
        GroupMediaItem, // <group-media-item>
        VueCustomScrollbar, // <vue-custom-scrollbar>
        GroupMediaItemLoading, // <group-media-item-loading>
    },
    props: {
        activeGroupMedia: { type: Boolean }, // 연속자료탭 선택 여부
        groupList: { type: Array|Object }, // 연속자료 데이터
        viewMedia: { type: Object }, // 보여지고 있는 미디어
        headHeight: { type: Number }, // 미디어 정보박스 높이
        isDataLoading: { type: Boolean }, // 데이터 통신중?
    },
    created(){
        const docWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.isMobileMode = docWidth<640;
        // console.log(docWidth, this.isMobileMode);
    },
}
</script>